import styled from 'styled-components'

const InfoRowGroup = styled.div`
  margin-top: -2px;
  margin-bottom: 12px;
`

export default InfoRowGroup